'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SearchIcon = function SearchIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === undefined ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === undefined ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['color', 'size', 'filled', 'className', 'children']);

  var classes = 'calcite-icon';
  if (className) classes += ' ' + className;

  if (size <= 16) {
    return _react2.default.createElement(
      'svg',
      _extends({}, props, { width: size, height: size, fill: color, viewBox: '0 0 16 16', className: classes }),
      filled ? _react2.default.createElement('path', { d: 'M14.65 13.74L9.732 8.823A5.387 5.387 0 1 0 5.5 10.904a5.358 5.358 0 0 0 3.288-1.142l4.92 4.92zM5.5 9.25a3.75 3.75 0 1 1 3.75-3.751 3.752 3.752 0 0 1-3.75 3.75z' }) : _react2.default.createElement('path', { d: 'M9.85 9.153a5 5 0 1 0-.69.69l4.631 4.631.69-.69zm-1.02-.326A3.973 3.973 0 0 1 6 10a4.002 4.002 0 1 1 2.83-1.172z' })
    );
  }

  if (size <= 24) {
    return _react2.default.createElement(
      'svg',
      _extends({}, props, { width: size, height: size, fill: color, viewBox: '0 0 24 24', className: classes }),
      filled ? _react2.default.createElement('path', { d: 'M22.289 20.91l-6.847-6.846a7.524 7.524 0 1 0-1.419 1.409l6.852 6.852zM4 9.5A5.5 5.5 0 1 1 9.5 15 5.506 5.506 0 0 1 4 9.5z' }) : _react2.default.createElement('path', { d: 'M21.995 21.288l-6.855-6.855a7.517 7.517 0 1 0-.707.707l6.855 6.855zm-17.092-7.19a6.501 6.501 0 1 1 9.6-.45l-.854.855a6.501 6.501 0 0 1-8.746-.405z' })
    );
  }

  return _react2.default.createElement(
    'svg',
    _extends({}, props, { width: size, height: size, fill: color, viewBox: '0 0 32 32', className: classes }),
    filled ? _react2.default.createElement('path', { d: 'M29.385 27.97l-8.643-8.642a10 10 0 1 0-1.414 1.414l8.643 8.643zM7.343 18.656a8 8 0 1 1 11.314 0 8 8 0 0 1-11.314 0z' }) : _react2.default.createElement('path', { d: 'M28.996 28.29l-9.454-9.456.268-.268a9.5 9.5 0 1 0-1.244 1.244l.268-.268 9.455 9.454zM6.42 18.581a8.6 8.6 0 1 1 12.162 0 8.6 8.6 0 0 1-12.162 0z' })
  );
};

exports.default = SearchIcon;